export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7631.29120f9f.jpg";